@use "~theme/typography";
@use "~theme/breakpoints";
@mixin border {
  border-radius: 8px;
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 10%);
}

@mixin card {
  @include border;
  background-color: var(--white);
  max-width: var(--max-desktop-width);
  flex-grow: 1;
  margin: 18px var(--card-gutter-width);
}

.card {
  @include card;
}

.introduction {
  padding: 16px 24px;
  text-align: center;

  @include breakpoints.desktop {
    padding: 24px 32px;
  }
}

.header {
  @include typography.heading2;
  color: var(--blue-01);
  margin: 0 0 4px;
}

.headerV3 {
  @include typography.heading2;
  color: var(--blue-01);
}

.subheading {
  margin-bottom: 0;
}

.subheadingV3 {
  margin-bottom: 15px;
}

.pageDivider {
  width: 100%;
  height: 1px;
  background-color: var(--gray-06);
  margin: 15px 0;
}

.content {
  padding: 24px 24px 0;

  @include breakpoints.desktop {
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
  }
}

.contentNew {
  padding: 24px 24px 0;
  background:white;

  @include breakpoints.desktop {
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
  }
}

.addressFieldGroup {
  @include breakpoints.mobile-large {
    display: grid;
    grid-gap: 0 16px;
    grid-template-columns: 1fr 1fr;
    align-items: start;
  }
  margin: 0px;
}

.alwaysVisible {
  display: inherit;
}

.field {
  margin: 0 0 16px;
}

.apt {
  margin: 3px 0 16px;
}

.fieldSpan {
  grid-column: 1 / span 2;
}

.buttonGroup {
  margin: 12px 0 16px;
}

.buttonGroupCustom {
  margin: 0px;
}

.radioButton {
  margin-bottom: 16px;
}

.emptyError {
  display: none;
}

.separator {
  border: 0;
  border-bottom: 1px solid var(--blue-01-at-30);
  margin-bottom: 24px;

  @include breakpoints.desktop {
    margin: {
      top: 0;
      bottom: 24px;
    }
  }
}

.toggle {
  margin-bottom: 16px;

  @include breakpoints.desktop {
    margin-top: 28px;
  }
}

.accommodationField {
  margin-top: 24px;
}

.contentBG {
  background: var(--gray-05);
}

.FieldLegend {
  position: initial;
  width: 100%;
  text-align: initial;
}


.sexCustom {
  color: var(--blue-01);
}